// Form validation for Bundle form
import { plaintextValidator } from '../fields';

export default {
  bundleName: plaintextValidator({ mandatory: true }),
  softwareList: {
    array: {
      presence: {
        allowEmpty: false
      }
    }
  }
};
